import { useSessionStorage } from '@cheqroom/hooks';
import { LoadingSpinner } from '@cheqroom/ui';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Workspace } from '../../api/discovery.api';
import { useGetWorkspaces } from '../../api/find-workspaces.api';
import { Step } from '../../App';
import { useLoadDiscovery } from './api.hooks';
import PasswordLoginForm from './PasswordLoginForm';

export const PasswordStep: FC = () => {
	// With cookie
	const {
		status: discoveryStatus,
		workspace: discoveryWorkspace,
		email,
		onGoBack,
		clearSessionAndGoToEmail,
	} = useLoadDiscovery();

	// Without cookie
	const navigateTo = useNavigate();
	const { workspaceId } = useParams<{ workspaceId: string }>();
	const { data: workspacesData, status: recentWorkspacesStatus } = useGetWorkspaces(
		{ ids: workspaceId ? [workspaceId] : [] },
		{ enabled: !!workspaceId }
	);
	const [emailFromSession] = useSessionStorage<string>('email');

	if (discoveryStatus === 'loading' || recentWorkspacesStatus === 'loading') {
		return <LoadingSpinner size="large" />;
	}

	// With cookie, only when the identity cookie email has access to the URL workspace.
	// A leftover cookie for another email must not lock the email field.
	if (discoveryStatus === 'success' && discoveryWorkspace) {
		return (
			<PasswordLoginForm
				workspace={discoveryWorkspace}
				email={email}
				onGoBackClick={onGoBack}
				canChangeEmail={!email}
			/>
		);
	}

	// Without cookie (or with a cookie for an email that has no access to this workspace)
	const workspace = workspacesData?.workspaces?.[0] as (Workspace & { url: string }) | undefined;
	const handleGoBackClick = () => {
		if (discoveryStatus === 'success') {
			// Clear the leftover identity cookie, else the next steps reuse the other email.
			return clearSessionAndGoToEmail();
		}

		navigateTo(Step.ENTER_EMAIL);
	};

	return (
		<PasswordLoginForm
			workspace={workspace}
			onGoBackClick={handleGoBackClick}
			email={emailFromSession}
			canChangeEmail
		/>
	);
};
